/* 
*  Copyright (c) Intel Corporation.  All Rights Reserved.
*
*/
/* Module Manager used to create and\or retrieve signleton objects
* Objects register with the module manager upon being loaded
*/
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import {  LoadScript , scriptHelper , getPersistentStorage } from "./bootstrap_web_ext";
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";
import { enableAnalyticsSDKForUWP } from "./Init";

// #ENDIF WebPack
function CreateModuleManager(factoryManager) {
	var ModuleManager =
	{
		"getSingleton": function (name) {
			var object = this._objects[name];
			if (object) return object;

			object = this.create(name);
			this._objects[name] = object;
			return object;
		},
		"create": function (name) {
			var factory = this._factoryManager.get(name);
			if (!factory) {
				logError("ModuleManager.create failed: " + name);
				return null;
			}
			return new factory();
		},
		"set": function (name, object) {
			this._objects[name] = object;
		},
		"_objects": {},
		"registerFactory": function (name, factoryFunction) { this._factoryManager.register(name, factoryFunction); },
		"setScriptFileMapping": function (objName, fileName) { this._factoryManager.setScriptFileMapping(objName, fileName); },
		"_factoryManager": factoryManager
	}
	return ModuleManager;
}

/* JSON Manager Manager used to load JSON files
*/
function CreateJSONManager() {
	var JSONManager =
	{
		"getSingleton": function (name) {
			var object = this._objects[name];
			if (object) return object;

			object = this.create(name);
			this.set(name, object);
			return object;
		},
		"create": function (name) {
			var fileName = this._getFileName(name);
			var jsonText = scriptHelper._readRawText(fileName);
			if (!jsonText) {
				// assume the error was logged
				return null;
			}

			try {
				return JSON.parse(jsonText);
				//return jsonText;
			}
			catch (e) {
				logError("Failed to load JSON object '" + name + "' from file '" + fileName + "': exception is " + e.message);
			}
			return null;
		},
		"set": function (name, object) {
			this._objects[name] = object;
		},
		"_objects": {},
		"setJSONFileMapping": function (objName, fileName) { this._fileNameOverrides[objName] = fileName; },
		"_getFileName": function (objName) {
			var fileName = this._fileNameOverrides[objName];
			if (fileName) return fileName;
			return this._getfileNameDefault(objName);
		},
		"_getfileNameDefault": function (objName) { return objName + ".json"; },
		"_fileNameOverrides": {}
	}
	return JSONManager;
}

function CreateFactoryManager() {
	var FactoryManager =
	{
		"get": function (name) {
			var factory = this._factoryFunctions[name];
			if (factory) return factory;
			LoadScript(this._getScriptName(name));
			factory = this._factoryFunctions[name];
			if (!factory) {
				logError("attempted to load " + name + " from file: " + this._getScriptName(name) + ", however, it didn't register properly with ModuleManager");
			}
			return factory;
		},
		"register": function (name, factory) {
			this._factoryFunctions[name] = factory;
		},
		"setScriptFileMapping": function (objName, fileName) { this._scriptNameOverrides[objName] = fileName; },
		"_getScriptName": function (objName) {
			var scriptName = this._scriptNameOverrides[objName];
			if (scriptName) return scriptName;
			return this._getscriptNameDefault(objName);
		},
		"_getscriptNameDefault": function (objName) { return objName + ".js"; },
		"_factoryFunctions": {},
		"_scriptNameOverrides": {}
	};
	return FactoryManager;
}

function CreateStorageManager() {
	var SettingsManager = {
		"get": function (name) {
			try {
				if (typeof name != "string") {
					this._logError("get: expected a string value. Actual value(" + name + ")");
					return;
				}

				var message = {
					'name': name
				};

				var response = getMessageBus().Request('SETTINGS_MANAGER_GET_PROPERTY', JSON.stringify(message));
				var responseObj = this._parseSettingsManagerResponse(response);
				if (!responseObj) {
					this._logError('get: No valid parsable response (' + response + ').');
					return null;
				}
				//TODO: Check if status is false
				return responseObj.value;
			}
			catch (e) {
				this._logError('get:' + e.message);
			}
		},
		"set": function (name, value, isVolatile) {
			try {
				var message = {
					'name': name,
					'value': value,
					'volatile': isVolatile
				};

				var response = getMessageBus().Publish('SETTINGS_MANAGER_SET_PROPERTY', JSON.stringify(message));
				// var responseObj = this._parseSettingsManagerResponse(response);
				// TODO: Add logs on what the request result was
			}
			catch (e) {
				this._logError('set: ' + e.message);
			}
		},
		"remove": function (name) {
			try {
				var message = {
					'name': name
				};

				var response = getMessageBus().Publish('SETTINGS_MANAGER_REMOVE_PROPERTY', JSON.stringify(message));
				// var responseObj = this._parseSettingsManagerResponse(response);
				// TODO: Add logs on what the request result was
			}
			catch (e) {
				this._logError('remove:' + e.message);
			}
		},
		"_parseSettingsManagerResponse": function (response) {
			if (!response) {
				return null;
			}
			var responseObj = JSON.parse(response);
			if (responseObj.error) {
				this._logError('_parseSettingsManagerResponse: Failed to get response: ' + responseObj.error);
				return null;
			}
			if (!enableAnalyticsSDKForUWP) {
				return responseObj.payload;
			}
			else {
				return responseObj;
			}
		},
		"_logInfo": function (msg) { logInformation('SettingsManager:' + msg); },
		"_logError": function (msg) { logError('SettingsManager:' + msg); }
	};
	var StorageManager =
	{
		"get": function (name) {
			try {
				if (typeof name != "string") {
					this._logError("get: expected a string value. Actual value(" + name + ")");
					return;
				}

				if (enableAnalyticsSDKForUWP) {
					return getPersistentStorage().getItem(name);
				}

				return SettingsManager.get(name);
			}
			catch (e) {
				this._logError('get:' + e.message);
			}
		},
		"set": function (name, value, isVolatile) {
			try {
				if (enableAnalyticsSDKForUWP) {
					return getPersistentStorage().setItem(name, value, isVolatile);
				}

				return SettingsManager.set(name, value, isVolatile);
			}
			catch (e) {
				this._logError('set: ' + e.message);
			}
		},
		"remove": function (name) {
			try {

				if (enableAnalyticsSDKForUWP) {
					return getPersistentStorage().removeItem(name);
				}

				return SettingsManager.remove(name);
			}
			catch (e) {
				this._logError('remove:' + e.message);
			}
		},
		"_logInfo": function (msg) { logInformation('StorageManager:' + msg); },
		"_logError": function (msg) { logError('StorageManager:' + msg); }
	};
	return StorageManager;
}

/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

export { CreateModuleManager, CreateJSONManager, CreateFactoryManager, CreateStorageManager };

// #ENDIF WebPack
